module.exports = __webpack_public_path__ + "assets/img/07.8f1f505e.png";